import { Input as AntInput } from 'antd';
import { PasswordProps } from 'antd/lib/input/Password';
import React from 'react';
import { EyeIcon, EyeSlashIcon } from '@revfluence/fresh-icons/regular';

const { Password: AntInputPassword } = AntInput;

export interface IInputPasswordProps extends PasswordProps {}

/**
 * Input Password component
 */
export const Password: React.FC<IInputPasswordProps> = (props) => {
  const iconCustomRender = (visible: boolean) =>
    visible ? <EyeIcon /> : <EyeSlashIcon />;
  const { iconRender = iconCustomRender } = props;

  return <AntInputPassword iconRender={iconRender} {...props} />;
};
